/**
 * Silhouette Page Functionality
 * Includes section numbering and other silhouette-related features
 */
(function() {
  // CSS for active section styling
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    .silhouette-section--active {
      transition: opacity 0.3s ease;
    }
  `;
  document.head.appendChild(styleElement);
  /**
   * Add sequential numbers to all silhouette section number elements
   */
  function initSilhouetteSectionNumbers() {
    // Select all section elements with the class 'silhouette-section'
    const silhouetteSections = document.querySelectorAll('.silhouette-section');
    
    if (!silhouetteSections.length) return;
    
    // Loop through each section and add numbers
    silhouetteSections.forEach((section, index) => {
      // Find the number container within this section
      const numberContainer = section.querySelector('.silhouette-section__number');
      
      if (numberContainer) {
        // Add the sequential number (1-based index) with leading zero
        const sectionNumber = index + 1;
        // Format with leading zero (01, 02, etc.)
        const formattedNumber = sectionNumber < 10 ? `0${sectionNumber}` : sectionNumber.toString();
        numberContainer.textContent = formattedNumber;
        
        // Add a class to indicate the number has been added
        numberContainer.classList.add('silhouette-section__number--initialized');
      }
    });
  }
  
  /**
   * Initialize all silhouette page functionality
   */
  function init() {
    initSilhouetteSectionNumbers();
    // Add other silhouette page functionality here as needed
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-initialize on window load to ensure all elements are available
  window.addEventListener('load', init);
})();